import { useCallback, useState } from "react";
import { getRegisteredDomains, deleteAllowedDomain } from "../../service/AdminService/adminDomainService";
import { message } from "antd";

const useDomain = () => {
    const [domains, setDomains] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalElements, setTotalElements] = useState(0);

    const fetchDomains = useCallback(async (page, size, query, isActive = true) => {
        setLoading(true);
        try {
            const response = await getRegisteredDomains(page - 1, size, query, isActive);
            
            if (response?.data) {
                const content = response.data.content || [];
                setDomains(content);
                setTotalElements(response.data.totalElements || 0);
                return response;
            } else {
                setDomains([]);
                setTotalElements(0);
                return null;
            }
        } catch (error) {
            console.error("Error loading domains:", error);
            message.error(error.message || 'Failed to load domains');
            setDomains([]);
            setTotalElements(0);
            return null;
        } finally {
            setLoading(false);
        }
    }, []);

    const deleteDomain = useCallback(async (id) => {
        setLoading(true);
        try {
            const result = await deleteAllowedDomain(id);
            message.success(result?.message || "Domain deleted successfully");
            return true;
        } catch (error) {
            message.error(error.message || "Failed to delete domain");
            return false;
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        domains,
        loading,
        totalElements,
        fetchDomains,
        deleteDomain
    };
};

export default useDomain;